import _ from 'lodash'

export default {
  methods: {
    getLink(item) {
      let fallback = "/" + this.$i18n.locale;

      let link = _.get(item, 'url.uri', fallback);

      // If we didn't find anything in url.uri; it could be an entity reference
      // In which case look in content.path
      if (link == fallback || link == null) {
        link = _.get(item, 'content.path', fallback);
      }

      // If content.path existed but was null, send them to our fallback link
      if (link == null) {
        link = fallback;
      }

      // If link isn't absolute; then send them to the main site
      if (!(link.includes('http'))) {
        link = process.env.VUE_APP_WK_FRONT_END_URL + link;
      }

      return link;
    },
    itemIsDefined(item, path) {
      return _.get(item, path, false)
    }
  }
}